/* What this contract calls the thing WAPA calls a workstream.
 *
 * WAPA runs workstreams. VIDE runs stages, and its deliverables are grouped
 * by 30, 60, 90 and 120 day buckets. They are the same idea and the same
 * column, so the app stores one list per contract and lets each one name it.
 * The name lives on the contract as workstream_label, which is a slightly
 * awkward column name for a thing whose whole point is that it is not always
 * called that, but renaming a column costs a migration and buys nothing.
 *
 * Everything user-facing goes through here, so a screen never hardcodes
 * "workstream" and then reads wrong on the VIDE contract.
 */

const DEFAULT = "Workstream";

export function term(contract, fallback = DEFAULT) {
  const named = String(contract?.workstream_label ?? "").trim();
  return named || fallback;
}

/* Plural, without the usual "Stages"/"Categorys"/"Phasess" embarrassment.
 *
 * Not a full pluraliser and does not need to be: it has to handle the words a
 * program manager actually types into that box. A word that already ends in
 * s is left exactly as it is, because somebody typing "Workstreams" meant the
 * plural and "Workstreamses" helps nobody. */
export function pluralise(word = "") {
  const w = String(word).trim();
  if (!w) return w;
  if (/s$/i.test(w)) return w;
  if (/(x|z|ch|sh)$/i.test(w)) return `${w}es`;
  if (/[^aeiou]y$/i.test(w)) return `${w.slice(0, -1)}ies`;
  return `${w}s`;
}

/* The four shapes a sentence ever needs. Lower case forms are for the middle
   of a sentence, where "5 Stages defined" reads like a title by accident. */
export const termPlural = (contract, fallback) => pluralise(term(contract, fallback));
export const termLower = (contract, fallback) => term(contract, fallback).toLowerCase();
export const termPluralLower = (contract, fallback) => termPlural(contract, fallback).toLowerCase();
